import { render, staticRenderFns } from "./empresaDefineLunch.vue?vue&type=template&id=b13cdf14&"
import script from "./empresaDefineLunch.vue?vue&type=script&lang=js&"
export * from "./empresaDefineLunch.vue?vue&type=script&lang=js&"
import style0 from "./empresaDefineLunch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports